export const comboDefSportAbilities = {
    collection: 'sportabilities_view_gridCombo',
    select: 'ID, FieldValue',
    top: '500',
    where: '',
    groupby: '',
    orderby: 'FieldValue',
    with0: 'true',
};
  